import { api } from "@/api/axios.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import { ApiGoal, ApiGoalPayload, ApiGoalSearchFilter } from "@/types/goals.types.ts";

export const apiEmployeeGoals = {
  search(employeeId: number, filter: ApiGoalSearchFilter) {
    return api.post<ApiPagedData<ApiGoal>>(`/api/v1/employees/${employeeId}/goals/search`, filter);
  },
  create(employeeId: number, payload: ApiGoalPayload) {
    return api.post<ApiGoal>(`/api/v1/employees/${employeeId}/goals`, payload);
  },
};
